import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { getSpacing } from '../../../util/spacing.js';
import { selectToken } from '../../../util/tokenSelector.js';
import { useDirectionContext } from '../../../contexts/session/Locale.js';
import { useThemeContext } from '../../../contexts/session/Theme.js';
import { SkeletonLoaderStyled } from './Skeleton.styled.js';

var _excluded = ["display", "shape", "width", "height", "label", "live"];
/**
 * @deprecated SkeletonLoader is deprecated and being replaced by SkeletonLoaderV3.
 * Skeleton represents a loading state of an underlying component. */
var SkeletonLoader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var display = props.display,
    shape = props.shape,
    width = props.width,
    height = props.height,
    label = props.label,
    _props$live = props.live,
    live = _props$live === void 0 ? 'assertive' : _props$live,
    rest = _objectWithoutProperties(props, _excluded);
  var direction = useDirectionContext();
  var theme = useThemeContext();
  var spacing = getSpacing(props, direction, theme.spacing);
  var borderRadius = shape === 'circle' ? selectToken(theme.radius, 'max') : undefined;
  return /*#__PURE__*/React.createElement(SkeletonLoaderStyled, _extends({}, rest, spacing, {
    ref: ref,
    $borderRadius: borderRadius,
    $display: display,
    $height: height,
    $width: width,
    role: "alert",
    "aria-live": live,
    "aria-label": label
  }));
});
SkeletonLoader.defaultProps = {
  display: 'inline-block',
  shape: 'rectangle',
  width: '32px',
  height: '32px',
  live: 'assertive'
};
var SkeletonLoaderMemoized = /*#__PURE__*/React.memo(SkeletonLoader);
SkeletonLoaderMemoized.displayName = 'SkeletonLoader';

export { SkeletonLoaderMemoized as SkeletonLoader };
//# sourceMappingURL=Skeleton.js.map
